import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app" }
const _hoisted_2 = { class: "navbar navbar-expand-lg" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = {
  href: "/seguro-de-vida/rumbo",
  class: "navbar-brand"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "navbar-nav ms-auto" }
const _hoisted_9 = {
  key: 0,
  class: "nav-item user-name"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item user-actions" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-out" }, null, -1)
const _hoisted_13 = { class: "sidebar" }
const _hoisted_14 = { class: "sidebar-info" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h4", null, "Acerca de Rumbo", -1)
const _hoisted_16 = { class: "sidebar-info__item" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Actualiza tus beneficiarios llamando al (01) 500-0000 ", -1)
const _hoisted_19 = { class: "sidebar-info__item" }
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Tu ahorro incluye un seguro de vida por S/ 25,000 para proteger a los que más amas", -1)
const _hoisted_22 = {
  key: 1,
  class: "sidebar-info__navigate"
}
const _hoisted_23 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isAdmin)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["layout", { open: _ctx.openSidebar }])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("a", _hoisted_4, [
                _createElementVNode("img", {
                  src: require('@/assets/images/app/rumbo-white.svg'),
                  loading: "lazy",
                  alt: ""
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("button", {
                class: "navbar-toggler mr-auto",
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSidebar()))
              }, _hoisted_7),
              _createElementVNode("ul", _hoisted_8, [
                (_ctx.user)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_9, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1))
                  : _createCommentVNode("", true),
                _hoisted_10
              ]),
              _createVNode(_component_b_dropdown, { class: "user-menu" }, {
                "button-content": _withCtx(() => [
                  _hoisted_11
                ]),
                default: _withCtx(() => [
                  _createElementVNode("li", null, [
                    _createVNode(_component_b_dropdown_item, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createTextVNode("Cerrar Sesión")
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              (!_ctx.isAdminPolices)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("img", {
                        src: require('@/assets/images/app/group.svg'),
                        alt: ""
                      }, null, 8, _hoisted_17),
                      _hoisted_18
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("img", {
                        src: require('@/assets/images/app/shield.svg'),
                        alt: ""
                      }, null, 8, _hoisted_20),
                      _hoisted_21
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.isAdminPolices)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createVNode(_component_router_link, { to: "./policies" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Pólizas")
                      ]),
                      _: 1
                    }),
                    (_ctx.isSuperAdmin)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_router_link, { to: "./operations" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Operaciones")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_router_link, { to: "./payments-upload" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Pagos")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_router_link, { to: "./promos-upload" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Promociones")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_router_link, { to: "./data-consistency" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Consistencia de datos")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_router_link, { to: "./persistence" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Persistecia de clientes")
                            ]),
                            _: 1
                          })
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_router_view)
          ])
        ], 2))
      : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
  ]))
}